import { render, staticRenderFns } from "./CreateTreatmentTypes.vue?vue&type=template&id=1b1d782c&scoped=true"
import script from "./CreateTreatmentTypes.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentTypes.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentTypes.vue?vue&type=style&index=0&id=1b1d782c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d782c",
  null
  
)

export default component.exports